(function ($) {

    $(document).ready(function () {
        const $header = $('header');
        const $html = $('html');
        const $toggle = $('.navbar-toggle');
        let canClick = true;

        // close Menu
        function closeMenu() {
            $header.removeClass('mobile-activated-menu');
            $html.removeClass('overflow-hidden');
            $toggle.addClass('collapsed');
            $('.navbar-collapse').removeClass('in').addClass('collapse').ariaExpanded = false;
        }

        $toggle.on('click', function (e) {
            if ($(this).hasClass('collapsed')) {
                $header.addClass('mobile-activated-menu');
                $html.addClass('overflow-hidden');
            } else {
                $header.removeClass('mobile-activated-menu');
                $html.removeClass('overflow-hidden');
            }
        });

        $(window).on('resize', function () {
            if ($(window).width() > 767) {
                if ($header.hasClass('mobile-activated-menu')) {
                    closeMenu();
                }
            }
        });


        // accordion menu tablet/mobile
        function initMobileAccordion() {
            const $menuItems = $(".mobile-main-menu ul li.menu-item-has-children > a");
            $menuItems.off("click").on("click", function (e) {

                if ($(window).width() <= 1080) {
                    if (!canClick) return;

                    if ($(this).attr('href') === '#' || $(this).parent().hasClass('menu-item-has-children')) {
                        e.preventDefault();
                    }

                    canClick = false;
                    const $parentLi = $(this).parent("li");
                    const $subMenu = $(this).siblings("ul");

                    if ($parentLi.hasClass("active")) {
                        $parentLi.removeClass("active");
                        $(this).removeClass("active");
                        $subMenu.slideUp(300);
                    } else {
                        $parentLi.addClass("active");
                        $(this).addClass("active");
                        $subMenu.slideDown(300);
                    }

                    setTimeout(() => {
                        canClick = true;
                    }, 400);
                }
            });
        }

        initMobileAccordion();

        $(window).on('resize', function () {
            if ($(window).width() > 767) {
                $(".mobile-main-menu ul li ul").removeAttr('style');
                $(".mobile-main-menu ul li").removeClass('active');
            }
        });
    });


    //anchors scroll
    $(document).ready(function () {
        let headerOffset = 68;

        function isAnchorLink(href) {
            return href && href.indexOf('#') !== -1;
        }

        function getHashFromHref(href) {
            return href.split('#')[1] || '';
        }

        function clearAnchorActive() {
            $('.nav a').each(function () {
                let href = $(this).attr('href');

                if (isAnchorLink(href)) {
                    $(this)
                        .parent('li')
                        .removeClass('current-menu-item current_page_item active');
                }
            });
        }

        function setActiveAnchorOnScroll() {
            let scrollTop = $(window).scrollTop() + headerOffset + 20;
            let activated = false;

            $('.nav a').each(function () {
                let href = $(this).attr('href');

                if (!isAnchorLink(href)) return;

                let hash = getHashFromHref(href);
                let $target = $('#' + hash);

                $(this).parent('li').removeClass('current-menu-item current_page_item active');

                if ($target.length) {
                    let sectionTop = $target.offset().top;
                    let sectionBottom = sectionTop + $target.outerHeight();

                    if (scrollTop >= sectionTop && scrollTop < sectionBottom && !activated) {
                        $(this).parent('li').addClass('current-menu-item current_page_item active');
                        activated = true;
                    }
                }
            });
        }

        // click to menu
        $('.nav a').on('click', function (e) {
            let href = $(this).attr('href');

            if (!isAnchorLink(href)) return;

            let parts = href.split('#');
            let url = parts[0];
            let hash = parts[1];
            let $target = $('#' + hash);

            if (!url || url === window.location.pathname || url === '/') {
                if ($target.length) {
                    e.preventDefault();

                    let offsetTop = $target.offset().top - headerOffset;

                    $('html, body').animate({
                        scrollTop: offsetTop
                    }, 600);
                }
            } else {
                e.preventDefault();
                window.location.href = url + '#' + hash;
            }

            $('.navbar-collapse').removeClass('in');
            $('header').removeClass('mobile-activated-menu');
            $('.navbar-toggle').addClass('collapsed');
        });

        clearAnchorActive();

        setActiveAnchorOnScroll();

        $(window).on('scroll', function () {
            setActiveAnchorOnScroll();
        });
    });

    $(window).on('load', function () {
        let hash = window.location.hash;

        if (hash.length) {
            let $target = $(hash);

            if ($target.length) {
                setTimeout(function () {
                    let headerOffset = 68;
                    let offsetTop = $target.offset().top - headerOffset;

                    $('html, body').animate({
                        scrollTop: offsetTop
                    }, 600);
                }, 100);
            }
        }
    });

})(jQuery);